// <s-card-slider> drives a scroll-snap image track with arrow and dot commands.
class SCardSlider extends HTMLElement {
  #ac;
  #track;
  #index = 0;

  connectedCallback() {
    this.#track = this.querySelector('[data-track]');
    if (!this.#track) return;
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    this.addEventListener('command', (e) => {
      const count = this.#slides().length;
      if (!count) return;
      if (e.command === '--prev') this.#go((this.#index - 1 + count) % count);
      if (e.command === '--next') this.#go((this.#index + 1) % count);
      if (e.command === '--go') this.#go(Number(e.source?.dataset.index || 0));
    }, opts);

    this.#track.addEventListener('scroll', () => {
      const width = this.#track.clientWidth || 1;
      const next = Math.round(Math.abs(this.#track.scrollLeft) / width);
      if (next !== this.#index) {
        this.#index = next;
        this.#syncDots();
      }
    }, { ...opts, passive: true });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #slides() {
    return this.#track.querySelectorAll('[data-slide]');
  }

  #go(index) {
    const slide = this.#slides()[index];
    if (!slide) return;
    this.#index = index;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#track.scrollTo({ left: slide.offsetLeft - this.#track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    this.#syncDots();
  }

  #syncDots() {
    this.querySelectorAll('[command="--go"]').forEach((dot) => {
      dot.setAttribute('aria-current', String(Number(dot.dataset.index) === this.#index));
    });
  }
}

if (!customElements.get('s-card-slider')) customElements.define('s-card-slider', SCardSlider);
